import React from "react";
import { Link } from "react-router-dom";
import { TeamForm } from "./TeamForm";

export default class CreateTeam extends React.Component {
  render() {
    return (
      <>
        <ul className="breadcrumb">
          <li>
            <Link to="/admin">Admin</Link>
          </li>
          <li className="active">Créer une équipe</li>
        </ul>

        <div className="page-title">
          <h2>
            <span className="fa fa-arrow-circle-o-left" /> Créer une équipe
          </h2>
        </div>

        <div className="page-content-wrap">
          <div className="panel panel-default">
            <div className="panel-body">
              <p>Indiquer les informations suivantes pour créer votre équipe</p>
            </div>
            <div className="panel-body form-group-separated">
              <TeamForm />
            </div>
          </div>
        </div>
      </>
    );
  }
}
